<div class="group-header" [class.clickable]="collapsible()">
  @if (collapsible()) {
    <!-- Lets a tap anywhere on the row toggle. The chevron button is the accessible control. -->
    <button
      type="button"
      class="group-toggle"
      tabindex="-1"
      aria-hidden="true"
      [disabled]="toggleDisabled()"
      (click)="toggle()"
    ></button>
  }

  <div class="group-heading">
    <div class="group-leading">
      <ng-content select="[groupHeaderLeading]" />
    </div>
    @if (label()) {
      <span class="group-label">{{ label() }}</span>
    }
    <ng-content select="[groupHeaderLabel]" />
  </div>

  <div class="group-actions">
    <ng-content select="[groupHeaderActions]" />
    @if (collapsible()) {
      <aw-icon-button
        class="group-chevron"
        [style]="'subtle'"
        [icon]="expanded() ? 'chevron-down' : 'chevron-right'"
        [ariaLabel]="toggleLabel() || label()"
        [ariaExpanded]="expanded()"
        [ariaControls]="controlsId()"
        [disabled]="toggleDisabled()"
        (click)="toggle()"
      />
    }
  </div>
</div>
